import { CameraIcon } from "@phosphor-icons/react/Camera";
import { Button } from "@freightsimple/ui-core/Controls/Button";

interface UploadPhotosCaptureButtonProps {
  /** Once a photo is attached the button shrinks to make room for the
   *  preview and asks for another photo instead. */
  afterFirstPhoto: boolean;
  onClick: () => void;
}

// The round face of the button. ui-core's Button has no round, oversized
// shape, so it renders in link mode (no chrome of its own) around this.
function CaptureDisc_({ afterFirstPhoto }: { afterFirstPhoto: boolean }) {
  const sizeClasses = afterFirstPhoto
    ? "size-36 gap-1.5 text-sm"
    : "size-56 gap-3 text-base";

  return (
    <span
      className={`flex flex-col items-center justify-center rounded-full bg-brand font-medium whitespace-normal text-white shadow-lg shadow-brand/30 transition hover:bg-brand/90 active:scale-95 ${sizeClasses}`}
    >
      <CameraIcon weight="fill" size={afterFirstPhoto ? 40 : 72} aria-hidden />
      <span className="max-w-[70%] text-center leading-tight">
        {afterFirstPhoto ? "Take another photo" : "Take shipment photo"}
      </span>
    </span>
  );
}

/**
 * The round button that opens the camera. Deliberately oversized: it's tapped
 * one-handed on a loading dock, often in gloves. It stays the same control after
 * the first photo, just smaller, so the shipper recognises it.
 */
export function UploadPhotosCaptureButton(
  props: UploadPhotosCaptureButtonProps,
) {
  return (
    <Button
      size="link"
      onClick={props.onClick}
      data-testid="upload-photos-capture-button"
    >
      <CaptureDisc_ afterFirstPhoto={props.afterFirstPhoto} />
    </Button>
  );
}
